import "VSS/LoaderPlugins/Css!Agile/Scripts/BacklogsHub/Planning/Components/BacklogIterationCard";

import { Card } from "Agile/Scripts/Common/Components/Card/Card";
import { Iteration } from "Agile/Scripts/Models/Iteration";
import * as BacklogContentViewResources from "Agile/Scripts/Resources/TFS.Resources.BacklogsHub.BacklogView";
import * as React from "react";
import { Link } from "OfficeFabric/Link";
import { format } from "VSS/Utils/String";
import { Team } from "Agile/Scripts/Models/Team";

export interface IBacklogIterationCardProps {
    iteration: Iteration;
    backlogUrl: string;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    team: Team;
}

export class BacklogIterationCard extends React.PureComponent<IBacklogIterationCardProps, any> {
    public render(): JSX.Element {
        const {
            team
        } = this.props;

        return (
            <Card className="backlog-iteration-card">
                <div className="backlog-title">
                    <Link href={this.props.backlogUrl} onClick={this._onClick}>
                        {format(BacklogContentViewResources.BacklogCardTitle, team.name)}
                    </Link>
                </div>
            </Card>
        );
    }

    private _onClick = (event: React.MouseEvent<HTMLElement>): void => {
        const {
            onClick
        } = this.props;

        if (onClick && !event.ctrlKey && !event.metaKey) {
            event.preventDefault();
            onClick(event);
        }
    }
}
